import {
  useAddKmContextAttribute,
  useRemoveKmContextAttribute,
  type KmContextItem,
  type KmContextLevel,
} from '@/entities/expert-report-km';
import type { KmContextAttributeOption } from './types';

/**
 * Приводит свой контекст уровня к новому составу списка: назначает добавленные атрибуты и снимает
 * убранные — по запросу на атрибут. Отказ по одному атрибуту не отменяет остальные: о причине
 * сообщает общий обработчик ошибок, а список показывает состав, который сохранил сервер.
 */
export const useChangeKmContext = () => {
  const { mutateAsync: addAttribute } = useAddKmContextAttribute();
  const { mutateAsync: removeAttribute } = useRemoveKmContextAttribute();

  return async (level: KmContextLevel, own: KmContextItem[], next: KmContextAttributeOption[]) => {
    const ownCodes = new Set(own.map((item) => item.attributeCode));
    const nextCodes = new Set(next.map((item) => item.code));

    const apply = async (operation: () => Promise<unknown>) => {
      try {
        await operation();
      } catch {
        // Причину показал общий обработчик ошибок, а следующий атрибут от этого отказа не зависит
      }
    };

    for (const { code } of next) {
      if (!ownCodes.has(code)) await apply(() => addAttribute({ ...level, attributeCode: code }));
    }
    for (const { attributeCode } of own) {
      if (!nextCodes.has(attributeCode)) await apply(() => removeAttribute({ ...level, attributeCode }));
    }
  };
};
